import * as Api from '@/api';
import router from '@/router';
import { _prepareErrors } from '@/utils/_function.js';

export default {
  name: 'DeleteStatementModal',
  props: {
    id: {
      type: Number
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    deleteStatement() {
      if (this.id) {
        Api.deleteStatement(this.id)
          .then(() => {
            this.$toastr('success', 'Заявление удалено.');
            this.closeModal();
            router.push({ path: '/statements' });
          })
          .catch((errors) => {
            if (errors) {
              _prepareErrors(errors).forEach((err) => {
                this.$toastr('error', err, 'Ошибка');
              });
            }
          });
      }
    }
  }
};
